import { cn } from "@/ds/utils";
import type { FC } from "react";

interface PercentageWheelProps {
	current: number;
	max: number;
	className?: string;
}

const RADIUS = 14;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export const PercentageWheel: FC<PercentageWheelProps> = ({ current, max, className }) => {
	const percentage = max > 0 ? Math.min(current / max, 1) : 0;
	const strokeDashoffset = CIRCUMFERENCE * (1 - percentage);

	return (
		<svg viewBox="0 0 36 36" className={cn("-rotate-90", className)}>
			<circle cx="18" cy="18" r={RADIUS} fill="none" stroke="currentColor" strokeWidth="4" className="opacity-20" />
			<circle
				cx="18" cy="18" r={RADIUS} fill="none"
				stroke="currentColor" strokeWidth="4"
				strokeDasharray={CIRCUMFERENCE}
				strokeDashoffset={strokeDashoffset}
				strokeLinecap="round" />
		</svg>
	);
};
